import {DefaultEventsMap, EventDataType, IEventManager, Listener, ListenerType} from '@gongxigames/framework/core/types';

export class EventManager<EventsMap = DefaultEventsMap> implements IEventManager<EventsMap> {
    protected _eventMap: Record<string|symbol, Listener[]> = {};

    public on<K extends keyof EventsMap>(id: K, callback: ListenerType<EventsMap[K]>, owner: Object, priority = 0): void {
        if (!this._eventMap[id as string]) {
            this._eventMap[id as string] = [];
        }

        this._eventMap[id as string].push({callback, owner, priority});
        this._eventMap[id as string].sort((a: Listener, b: Listener) => {
            return (b.priority || 0) - (a.priority || 0);
        });
    }

    public off<K extends keyof EventsMap>(id: K, owner: Object): void {
        const listeners: Listener[] = this._eventMap[id as string] || [];
        const index: number = listeners.findIndex((listener: Listener) => {
            return listener.owner === owner;
        });

        if (index > -1) {
            listeners.splice(index, 1);
        }
    }

    public emit<K extends keyof EventsMap>(id: K, ...args: EventDataType<EventsMap[K]>): void {
        const listeners: Listener[] = this._eventMap[id as string];

        if (listeners) {
            for (const listener of listeners) {
                listener.callback(...args);
            }
        }
    }

    public hasListener<K extends keyof EventsMap>(id: K, owner: Object): boolean {
        const listeners: Listener[] = this._eventMap[id as string] || [];
        const listener = listeners.find((listener: Listener) => {
            return listener.owner === owner;
        });

        return !!listener;
    }

    public getNumberEvents(): number {
        let count = 0;

        for (const id in this._eventMap) {
            if (this._eventMap.hasOwnProperty(id)) {
                count += this._eventMap[id].length;
            }
        }

        return count;
    }

    public clear(): void {
        this._eventMap = {};
    }
}
